// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"searchBar_searchBar__ynlWs","light":"searchBar_light__oFEpx","buttonWrapper":"searchBar_buttonWrapper__yoRs9"};